import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style17({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      activeItemNameKey="codeName"
      activeItemIconName="globe"
      onClick={onClick}
    />
  );
}
